import styled from '@emotion/styled';

export const Container = styled.div`
  transition: border 0.25s ease-in-out;

  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 8px;
  left: -6px;
  &:hover {
    border: 1px solid #d9b244;
    cursor: pointer;
  }
`;

export const IconContainer = styled.div`
  position: absolute;
  top: calc(62px / 2 - 30px / 2 / 2); // 62 высота блока с логотипом; 30 высота иконки
  opacity: 0;
  transition: opacity 0.25s ease-in-out;

  &.show {
    opacity: 1;
  }
`;

export const MainBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const BackgroundList = styled.div`
  display: flex;
  flex-direction: row;
  left: -6px;
  position: relative;
  flex-wrap: wrap;

  gap: 8px;
`;

export const ButtonsBlock = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;
  flex-wrap: wrap;
`;

export const BackgroundItemContainer = styled.div<{ isActive: boolean | undefined }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  gap: 8px;
  padding: 6px;

  transition: border 0.25s ease-in-out;
  border: ${({ isActive }) => (isActive ? '1px solid #D9B244' : '1px solid transparent')};
  border-radius: 8px;
  cursor: pointer;

  &.hover {
    &:hover {
      border: 1px solid ${({ theme, isActive }) => (isActive ? theme.colors.AccentNaplesYellow : theme.colors.AccentMediumChampagne)};
    }
  }
`;

export const ImageBlock = styled.div<{ color?: string; imgUrl?: string }>`
  width: 94px;
  height: 62px;

  background: ${({ color, imgUrl }) => color ?? `url(${imgUrl}) -4px -4px`};
  background-size: auto;

  border: 1px solid #9093aa;
  border-radius: 8px;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;

  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ColorBlock = styled.div`
  display: flex;
  flex-direction: row;
  gap: 6px;
`;

export const ColorIcon = styled.div<{ color?: string; imgUrl?: string }>`
  width: 10px;
  height: 10px;
  background: ${({ color, imgUrl }) => color ?? `url(${imgUrl})`};
  background-size: 14px;
  border: 1px solid #9093aa;
  border-radius: 1px;
`;
